<script setup lang="ts">
import { reactive, ref, toRaw } from 'vue'
import { NForm, NFormItem, NInput, NButton, NDivider, NIcon, FormRules, FormItemRule, FormInst } from 'naive-ui'
import { Google as GoogleIcon } from '@vicons/fa'
import { useAuthSignUpStore } from "@/stores/auth/signup.store";
import { loginRules } from "@/ts/formValidationRules";

const formRef = ref<FormInst | null>(null)

const formData = reactive({
  email: '',
  password: '',
  password_confirmation: '',
})

const signupRules : FormRules = {
  ... loginRules,
  password_confirmation: [{
    required: true,
    validator (rule: FormItemRule, value: string) {
      if (!value) {
        return new Error('Password confirmation is required')
      } else if (value !== formData.password) {
        return new Error('Password confirmation is not the same as password')
      }

      return true
    },
    trigger: ['input', 'blur']
  }]
}

const authSignUpStore = useAuthSignUpStore()

const submitLogin = () => {
  formRef.value?.validate((errors) => {
    if (!errors) {
      authSignUpStore.signUp(toRaw(formData))
    }
  })
}
</script>

<template>
  <div class="sign-up-form">
    <!-- Sign up component -->
    <p class="body-text text-align-center registration-warning">
      <span>Have an account already? </span>
      <router-link class="simple-link" to="/login">Log In</router-link>
    </p>

    <h1 class="heading h1 text-align-center page-title">Sign up to Augmentify</h1>

<!--    <n-button class="button" size="large" disabled>-->
<!--      <template #icon>-->
<!--        <n-icon>-->
<!--          <google-icon class="icon-full" style="width: 100%; height: auto;" />-->
<!--        </n-icon>-->
<!--      </template>-->
<!--      Continue with Google-->
<!--    </n-button>-->

<!--    <n-divider>or</n-divider>-->

    <div class="form-wrapper">
      <div class="input-group">
        <n-form ref="formRef" class="input-group" inline :model="formData" :rules="signupRules">
          <n-form-item path="email">
            <n-input v-model:value="formData.email" size="large" round placeholder="Yourname@email.com" class="form-input" />
          </n-form-item>
          <n-form-item path="password">
            <n-input v-model:value="formData.password" type="password" show-password-on="click" size="large" round placeholder="Create a password" class="form-input" />
          </n-form-item>
          <n-form-item path="password_confirmation">
            <n-input v-model:value="formData.password_confirmation" type="password" show-password-on="click" size="large" round placeholder="Confirm password" class="form-input" />
          </n-form-item>


          <n-form-item>
            <n-button class="button" size="large" attr-type="button" @click="submitLogin">
              SIGN UP
            </n-button>
          </n-form-item>
        </n-form>

        <p class="body-text-sm text-align-center">
          By continuing <span class="text-purple">you agree</span> that you have read our Privacy Policy.
          You also authorize Augmentify to send you emails.
        </p>
      </div>
    </div>
  </div>
</template>

<style>

</style>